import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { GuardConfirmComponent } from './guard-confirm/guard-confirm.component';

export interface ComponentCanDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean>  | boolean ;
}

@Injectable()
export class FormGuardGuard implements CanDeactivate<ComponentCanDeactivate> {
  
  constructor(
    private injector: Injector,
    private appRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver) {}

  canDeactivate(component: ComponentCanDeactivate): Observable<boolean> | Promise<boolean>  | boolean {
    if (component.canDeactivate()) {
      return true;
    } else {
      const factory = this.componentFactoryResolver.resolveComponentFactory(GuardConfirmComponent);
      const componentRef = factory.create(this.injector);
      componentRef.instance.title = 'Confirmation';
      componentRef.instance.message = 'Your changes have not been saved. Are you sure you want to leave this page?';
      const confirmed = new Promise<boolean>((resolve) => {
        componentRef.instance.confirmed.subscribe((result: boolean) => {
          componentRef.destroy();
          resolve(result);
        });
      });
      this.appRef.attachView(componentRef.hostView);
      document.body.appendChild(componentRef.location.nativeElement);
      return confirmed.then((result)=>{
        return result
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/form-guard.guard.ts